import React, { useState } from "react";
import "./ReportFactory.scss";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import FormatDate from "./FormatDate";
import LoadingSpinner from "./LoadingSpinner";
import { Button } from "primereact/button";
import { FilterMatchMode } from "primereact/api";
import Intersection from "../Plan/intersection";
import { statusTemplate } from "../../components/utils";
import { Paginator } from "primereact/paginator";
import ModalFilterCategoryFactoryInlate from "./ModalFilterCategoryFactoryInlate";
import QR from "../Plan/QR";
import CustomMultiSelect from "../../constants/CustomMultiSelect";
import { formatDate } from "../../components/utils";

const ProductInlate = ({ productInlateFactory, onPaginationChange }) => {
    const [expandedRows, setExpandedRows] = useState([]);
    const [selectFactoryCode, setSelectFactoryCode] = useState(null);
    const [dialogLocationVisible, setDialogLocationVisible] = useState(false);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [openModal, setOpenModal] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [qrDetail, setQrDetail] = useState(null);
    const [visible3, setVisible3] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        "Building.buildingCode": {
            value: null,
            matchMode: FilterMatchMode.CONTAINS,
        },
        categoryName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        factoryCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        unit: { value: null, matchMode: FilterMatchMode.CONTAINS },
        quantity: { value: null, matchMode: FilterMatchMode.CONTAINS },
        intendFinishDate: { value: null, matchMode: FilterMatchMode.DATE_IS },
    });

    const handleTeamProgress = (rowData) => {
        setSelectFactoryCode(rowData.factoryCode);
        setDialogLocationVisible(true);
        setSelectedRow(rowData);
    };

    const onPageChange = (event) => {
        const newFirst = event.first;
        const newRows = event.rows;

        setFirst(newFirst);
        setRows(newRows);
        if (onPaginationChange) {
            onPaginationChange(newFirst, newRows);
        }
    };
    const handleDetailScanned = (detail) => {
        setQrDetail(detail);
    };

    const handleSelectionChange = (e) => {
        const selected = e.value || [];
        const currentPageItems = productInlateFactory?.data?.items || [];

        // Loại bỏ các phần tử thuộc trang hiện tại khỏi selectedProducts
        const filteredProducts =
            selectedProducts?.filter(
                (item) => !currentPageItems.some((row) => row.id === item.id),
            ) || [];

        // Gộp các phần tử không bị xóa với phần tử vừa chọn
        const updatedSelection = [...filteredProducts, ...selected];

        // Loại bỏ phần tử trùng lặp
        const uniqueSelection = Array.from(
            new Map(updatedSelection.map((item) => [item.id, item])).values(),
        );

        setSelectedProducts(uniqueSelection);
    };

    return (
        <div className="border-round-lg py-4 bg-white px-3">
            <div className="flex align-items-center mb-2 justify-content-between">
                <p
                    style={{
                        color: "#5c5c5c",
                        fontWeight: "700",
                    }}
                >
                    Trễ tiến độ
                </p>
                <div className="flex gap-4">
                    <Button
                        label="Lọc theo hạng mục"
                        onClick={() => setOpenModal(true)}
                    ></Button>
                </div>
            </div>

            {productInlateFactory && productInlateFactory.data ? (
                <div>
                    <DataTable
                        // paginator
                        // rows={10}
                        // rowsPerPageOptions={[10, 25, 50, 100, 500]}
                        rowClassName="custom-row-class-factory"
                        size="small"
                        onRowToggle={(e) => setExpandedRows(e.data)}
                        value={productInlateFactory?.data?.items}
                        emptyMessage="Không có dữ liệu"
                        scrollable
                        scrollHeight="50vh"
                        filters={filters}
                        onFilter={(e) => setFilters(e.filters)}
                        selectionMode="checkbox"
                        selection={selectedProducts || []}
                        onSelectionChange={handleSelectionChange}
                        dataKey="id"
                    >
                        <Column selectionMode="multiple"></Column>
                        <Column
                            header="STT"
                            body={(rowData, options) => (
                                <div className="text-center">
                                    {first + options.rowIndex + 1}
                                </div>
                            )}
                            style={{ width: "3%" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Tên công trình"
                            field="Building.name"
                            style={{ minWidth: "150px" }}
                            filter
                        />
                        <Column
                            header="Hạng mục"
                            field="categoryName"
                            style={{ minWidth: "200px" }}
                            filter
                        />
                        <Column
                            header="Phân loại"
                            field="classify"
                            style={{ width: "5%", minWidth: "100px" }}
                            filterPlaceholder="Tìm kiếm mã ĐH..."
                        ></Column>
                        <Column
                            header="Chi tiết SP"
                            field="detail"
                            style={{ width: "5%", minWidth: "100px" }}
                        ></Column>
                        <Column
                            header="Thứ tự ưu tiên"
                            field="priority"
                            style={{ width: "8%", minWidth: "100px" }}
                        ></Column>
                        <Column
                            header="Mã nhà máy"
                            field="factoryCode"
                            style={{ minWidth: "100px" }}
                            filter
                        />
                        <Column
                            header="ĐVT"
                            field="unit"
                            style={{ minWidth: "50px" }}
                            filter
                        />
                        <Column
                            header="Số lượng"
                            field="quantity"
                            style={{ minWidth: "70px" }}
                        />
                        <Column
                            header="Ngày hoàn thành"
                            field="endedDate"
                            body={(rowData) => (
                                <span style={{ color: "red" }}>
                                    {FormatDate(rowData.endedDate)}
                                </span>
                            )}
                            style={{ minWidth: "100px" }}
                            align="center"
                            alignHeader="center"
                            sortable
                        />
                        <Column
                            header="Định vị"
                            body={(rowData) => (
                                <div className="text-center">
                                    <Button
                                        onClick={() =>
                                            handleTeamProgress(rowData)
                                        }
                                        icon="pi pi-map-marker"
                                        rounded
                                        text
                                        severity="secondary"
                                        aria-label="Bookmark"
                                        style={{ color: "black" }}
                                    />
                                    <p>
                                        {rowData.status !==
                                            "Hoàn thành đúng tiến độ" &&
                                        rowData.status !==
                                            "Hoàn thành trễ tiến độ"
                                            ? rowData.teamWorking
                                            : "Đã giao"}
                                    </p>
                                    <p>
                                        {formatDate(
                                            rowData?.teamProductionDate,
                                        )}
                                    </p>
                                </div>
                            )}
                            alignHeader={"center"}
                            align={"center"}
                            style={{ minWidth: "100px" }}
                        ></Column>
                        <Column
                            header="In QR"
                            body={(rowData) => (
                                <div className="text-center">
                                    <Button
                                        onClick={() => {
                                            setQrDetail(rowData);
                                            setVisible3(true);
                                        }}
                                        icon="pi pi-qrcode"
                                        rounded
                                        text
                                        severity="secondary"
                                        aria-label="QR"
                                        style={{ color: "black" }}
                                    />
                                </div>
                            )}
                            style={{ width: "8%", minWidth: "100px" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Ghi chú"
                            field="technicalNote"
                            style={{ minWidth: "200px" }}
                        />
                    </DataTable>
                    <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={productInlateFactory?.data?.totalItems}
                        rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                        onPageChange={onPageChange}
                    />
                    <Intersection
                        visible={dialogLocationVisible}
                        onHide={() => setDialogLocationVisible(false)}
                        factoryCode={selectFactoryCode}
                        rowData={selectedRow}
                    />
                    <ModalFilterCategoryFactoryInlate
                        visible={openModal}
                        onHide={() => setOpenModal(false)}
                        data={selectedProducts}
                    />
                    <QR
                        isShow={visible3}
                        hiden={() => setVisible3(false)}
                        detail={qrDetail}
                        onDetailScanned={handleDetailScanned}
                    />
                </div>
            ) : (
                <LoadingSpinner />
            )}
        </div>
    );
};

export default ProductInlate;
